module.exports = __webpack_public_path__ + "img/faisal.3c3df175.png";